// extracted by mini-css-extract-plugin
export var paginationContainer = "_73-0";